document.addEventListener('DOMContentLoaded', function ()
{
  var blocks = document.querySelectorAll('[data-long-product-image]');

  blocks.forEach(function (block)
  {
    var frame = block.querySelector('[data-long-product-image-frame]');
    var showButton = block.querySelector('[data-long-product-image-show-button]');
    var closeButton = block.querySelector('[data-long-product-image-close-button]');

    if (!frame || !showButton || !closeButton)
    {
      return;
    }

    showButton.addEventListener('click', function ()
    {
      block.classList.add('is-expanded');
      frame.classList.add('is-expanded');
      showButton.setAttribute('aria-expanded', 'true');
    });

    closeButton.addEventListener('click', function ()
    {
      block.classList.remove('is-expanded');
      frame.classList.remove('is-expanded');
      showButton.setAttribute('aria-expanded', 'false');

      block.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });
});